import { put } from "redux-saga/effects";
import http from "~/utils/config/http";
import axios from "axios";
import { activeError, activeSuccess } from "~/components/Messages/actions";
import { BPM_MIDDLEWARE, IFLOW_APP } from "~/utils/constants";
import {
  setProcesses,
  setIflowFormdata,
  setIflowDocuments,
  resetIflowDocuments,
  setIflowTriggerLoading,
  setIflowMetadataPreview,
  setIsSubstitutingIflowDocumentDone,
} from "./actionTypes";

import { setTableFileSignClicked } from "~/store/ducks/processesSignature/actionTypes";

export function* findIflowProcessesByFilters({ payload }) {
  try {
    const resp = yield http.post(
      "/validprocs/process",
      payload,
      BPM_MIDDLEWARE
    );
    yield put(setProcesses(resp.data));
    console.log("findIflowProcessesByFilters", resp.data);
  } catch (e) {
    yield put(activeError("messages.error"));
  }
}

//iFlow/inicio_flow.jsp?
export function* getIflowFormdata({ data }) {
  try {
    const resp = yield http.get(`${data.url}`, IFLOW_APP);
    if (typeof resp?.data === "string" && resp?.data?.includes(`{"form" :`)) {
      let arr = resp.data.split(`{"form" :`);
      try {
        let re = /\"\" style=\"/g;
        let transformedString = (`{"form" :` + arr[1]).replace(re, '" style=');
        //Remove All Line Breaks from a String
        transformedString = transformedString
          .replace(/\\/g, "\\\\")
          .replace(/(\r\n|\n|\r|\t)/gm, "");
        let obj = JSON.parse(transformedString);
        yield put(setIflowTriggerLoading(true));
        yield put(setIflowFormdata(obj));
      } catch (error) {
        console.log(error);
        yield put(activeError("messages.error"));
        yield put(setIflowFormdata(false));
      }
    } else {
      //set all html response
      yield put(
        setIflowFormdata({
          responseMessage: resp.data,
          url: resp?.request?.responseURL,
        })
      );
    }
  } catch (e) {
    console.log(e);
    yield put(activeError("messages.error"));
    const { response } = e;
    if (response?.data?.includes(`<div class="error_msg">`)) {
      let arr = response.data.split(`<div class="error_msg">`);
      let arr1 = arr[1].split("</div>");
      yield put(
        setIflowFormdata({
          responseMessage: arr1[0],
          url: response?.request?.responseURL,
        })
      );
    } else yield put(setIflowFormdata(false));
  }
}

//iFlow/Form/form.jsp?
export function* postIflowFormData({ formdata, url }) {
  try {
    const resp = yield http.post(url, formdata, IFLOW_APP);

    if (resp.data.includes(`{"form" :`)) {
      let arr = resp.data.split(`{"form" :`);
      try {
        let re = /\"\" style=\"/g;
        let transformedString = (`{"form" :` + arr[1]).replace(re, '" style=');
        //Remove All Line Breaks from a String
        transformedString = transformedString
          .replace(/(\r\n|\n|\r|\t)/gm, "")
          .replace(/\\/g, "\\\\");
        //console.log(transformedString)
        let obj = JSON.parse(transformedString);
        yield put(setIflowFormdata(obj));
      } catch (error) {
        yield put(activeError(error));
        yield put(setIflowFormdata(null));
      }
    } else {
      //set all html response
      yield put(
        setIflowFormdata({
          responseMessage: resp.data,
          url: resp?.request?.responseURL,
        })
      );
    }
  } catch (e) {
    yield put(setIflowFormdata(null));
  }
}

//iFlow/document?
export function* getIflowDocument({ data }) {
  let error;
  for (let i = 0; i < 2; i++) {
    try {
      error = null;
      //yield put(resetIflowDocuments());
      const resp = yield axios.get(`${data.url}`, { responseType: "blob" });
      yield put(setIflowDocuments(resp.data, data.docid, data.filename));
      break;
    } catch (e) {
      error = e;
    }
  }
  if (error) {
    yield put(activeError(`Não conseguimos obter o documento  ${data.docid}`));
    yield put(resetIflowDocuments());
    yield put(setTableFileSignClicked(false));
  }
}

//iFlow/DocumentService?
export function* substituteIflowDocument({ url, data, updateCoords }) {
  let error;
  for (let i = 0; i < 2; i++) {
    error = "";
    try {
      yield put(setIsSubstitutingIflowDocumentDone(true));
      const resp = yield http.post(url, data, IFLOW_APP);

      if (
        resp.status === 200 &&
        updateCoords.docid &&
        updateCoords.numpages &&
        updateCoords.x &&
        updateCoords.y &&
        updateCoords.flowId &&
        updateCoords.pid &&
        updateCoords.subpid
      ) {
        try {
          const response = yield http.get(`/jsessionidretriever`, IFLOW_APP);
          if (response?.data?.jsessionId) {
            yield http.post(`/api/signature-coordinates/save`, {
              jsessionId: response?.data?.jsessionId,
              docId: updateCoords.docid,
              flowid: updateCoords.flowId,
              pid: updateCoords.pid,
              subpid: updateCoords.subpid,
              hash: updateCoords.isHash,
              pageNumber: updateCoords.numpages,
              newPosX: updateCoords.x,
              newPosY: updateCoords.y,
            });
          }
        } catch (e) {
          console.log(e);
        }
        yield put(activeSuccess("general.successSignedDocument"));
      } else {
        yield put(activeSuccess("general.successSignedDocument"));
      }
      yield put(setIsSubstitutingIflowDocumentDone(false));
      break;
    } catch (e) {
      error = e;
    }
  }

  if (error) {
    yield put(setIsSubstitutingIflowDocumentDone(false));
    yield put(
      activeError(
        `Não conseguimos substituir o documento  ${updateCoords.docid}`
      )
    );
  }
}

//Form/detail.jsp?flowid=${flowid}&pid=${pNumber}&subpid=${subPid}&procStatus=-4&fwSearch=true&uri=Forward/forward.jsp&op=10`;
export function* getIflowMetadataPreview({ data }) {
  try {
    const resp = yield http.get(`${data.url}`, IFLOW_APP);
    try {
      if (typeof resp.data === "object") {
        yield put(setIflowMetadataPreview(resp.data));
      } else if (typeof resp.data === "string") {
        //Remove trailing comma from last object
        const regex = /\,(?!\s*?[\{\[\"\'\w])/g;
        //Remove All Line Breaks from a String
        let transformedString = resp?.data
          ?.replace(/(\r\n|\n|\r|\t)/gm, "")
          ?.replace(/\\/g, "\\\\")
          ?.replace(regex, "");
        let obj = JSON.parse(transformedString);

        /*
        let testData =
          '{"metadata": [ { "name": "Título", "value": "Atribuição de apoios económicos a cuidados de saúde" }, { "name": "Assunto", "value": "teste" }, { "name": "Nome do Cliente Municipal", "value": "" }, { "name": "NIF", "value": "" }, { "name": "Tramitação", "value": { "row": [ {"col": [ { "header": "true", "value": "Ordem" }, { "header": "true", "value": "Acção" }, { "header": "true", "value": "Por" }, { "header": "true", "value": "Em" } ] }, {"col": [ { "header": "false", "value": "1" }, { "header": "false", "value": "Informado" }, { "header": "false", "value": "alexandra.rodrigues" }, { "header": "false", "value": "2022-10-10 21:42" } ]}, {"col": [ { "header": "false", "value": "2" }, { "header": "false", "value": "Encaminhado para teresa.lopes" }, { "header": "false", "value": "alexandra.rodrigues" }, { "header": "false", "value": "2022-10-14 08:41" } ]} ] } } ] }';

        testData = testData?.replace(regex, "");
        let obj = JSON.parse(testData);*/

        yield put(setIflowMetadataPreview(obj));
      }
    } catch (error) {
      console.log(error);
      yield put(setIflowMetadataPreview(null));
    }
  } catch (e) {
    console.log(e);
    yield put(setIflowMetadataPreview(null));
  }
}
